import axios from "axios"
import { useState, useEffect } from "react"
import { Link as RouterLink } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"

import FormControl from "@material-ui/core/FormControl"
import TextField from "@material-ui/core/TextField"
import Button from "@material-ui/core/Button"
import Typography from "@material-ui/core/Typography"
import Box from "@material-ui/core/Box"
import Link from "@material-ui/core/Link"
import InputAdornment from "@material-ui/core/InputAdornment"
import AccountCircleIcon from "@material-ui/icons/AccountCircle"

import { AxiosHelper } from "common/helpers"
import { AuthApi } from "common/api"
import { LocalStorageKey } from "common/helpers"
import { useLocalStorage } from "common/hooks"
import { AuthActions } from "store/actions"
import { AuthLayout } from "./AuthLayout"
import { PasswordTextFieldLogin } from "components/partials"
import { Alert } from "components/widgets"

const LoginController = () => {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const authActions = AuthActions.useActions()

    const [, setUser] = useLocalStorage(LocalStorageKey.User)
    const [, setToken] = useLocalStorage(LocalStorageKey.Token)
    const [, setRefreshToken] = useLocalStorage(LocalStorageKey.RefreshToken)

    // TODO: Thomas
    const [payload, setPayload] = useState({ email: "", password: "" })
    //const [payload, setPayload] = useState<AuthApi.LoginPayload>({ email: 'super.admin@forsale-s.de', password: 'Toscolano2510!' });
    //const [payload, setPayload] = useState<AuthApi.LoginPayload>({ email: 'admin@mark-money.com', password: 'Toscolano2510!' });
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)
    const [fontSize, setFontSize] = useState(window.innerWidth * 0.015)

    useEffect(() => {
        const handleResize = () => {
            setFontSize(window.innerWidth * 0.015);
        }

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, [])


    const onChange = key => event => {
        setPayload({ ...payload, [key]: event.target.value })
    }

    async function onSubmit(event) {
        event.preventDefault()
        setIsLoading(true)

        if (isLoading) {
            console.log('isLoading')
            return;
        }

        try {
            const response = await AuthApi.login(payload)
            const { user, token, refreshToken } = response.data

            // backward compatibility
            dispatch({ type: "SET_TOKEN", payload: `Bearer ${token}` })
            dispatch({ type: "USER_LOGIN_SUCCESS", payload: user })

            setUser(user)
            setToken(token)
            setRefreshToken(refreshToken)
            authActions.login(user)

            // We reload to force clear stored data in memory.
            window.location.reload()
        } catch (error) {
            if (axios.isAxiosError(error)) {
                if (error.message === 'Network Error') {
                    setError({ general: 'Keine Verbindung zum Server' })
                } else {
                    const parsed = AxiosHelper.parseError(error)
                    if (typeof parsed === "string") {
                        setError({ general: parsed })
                    } else {
                        setError({ general: t("view.login.errorInvalidEmailPassword") })
                    }
                }
            } else {
                setError({ general: t("errors.somethingWentWrong") })
            }
        } finally {
            setIsLoading(false)
        }
    }

    const styleButton = {
        backgroundColor: "black",
        fontWeight: "bold",
        fontSize: fontSize,
        padding: "10px 60px 10px 60px"
    }

    let timestamp = "" + new Date().getTime()

    return (
        <div id={timestamp}>
            <AuthLayout>
                {error?.general && <Alert severity="error">{error.general}</Alert>}

                <Box width="100%" component="form" onSubmit={onSubmit}>
                    <FormControl fullWidth margin="normal">
                        <TextField
                            required
                            label={t("view.login.emailLabel")}
                            type="email"
                            value={payload.email}
                            onChange={onChange("email")}
                            autoComplete="username"
                            error={Boolean(error?.email)}
                            helperText={error?.email}
                            InputLabelProps={{ style: { color: "white", fontSize } }}
                            InputProps={{
                                style: {
                                    color: "white",
                                    fontWeight: "bold",
                                    fontSize,
                                    borderBottom: "1px solid white"
                                },
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <AccountCircleIcon />
                                    </InputAdornment>
                                )
                            }}
                        />
                    </FormControl>

                    <FormControl fullWidth margin="normal">
                        <PasswordTextFieldLogin
                            required
                            label={t("view.login.passwordLabel")}
                            value={payload.password}
                            onChange={onChange("password")}
                            autoComplete="current-password"
                            error={Boolean(error?.password)}
                            helperText={error?.password}
                        />
                    </FormControl>

                    <FormControl
                        margin="normal"
                        className="w-full flex justify-center items-center"
                    >
                        <Button
                            style={styleButton}
                            color="primary"
                            variant="contained"
                            type="submit"
                        >
                            {isLoading
                                ? t("view.login.submitButtonLoading").toLocaleUpperCase()
                                : t("general.login").toLocaleUpperCase()}
                        </Button>
                    </FormControl>

                </Box>

                <Typography className="w-full flex justify-center items-center">
                    <Link
                        style={{ color: "white" }}
                        component={RouterLink}
                        to="/forgot-password"
                    >
                        {t("view.login.forgotPasswordLink")}
                    </Link>
                </Typography>
            </AuthLayout>
        </div>
    )
}

export default LoginController
